import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import storageManager from '@/api/storageManager';
import {
	ORDER_STATUS_PHASE,
	ORDER_STATUS_TIMING,
} from '../constants/orderStatus.constants';
import { buildRedirectDestination } from '../utils/orderStatusRedirect';

const useOrderStatusSuccessRedirect = (params, phase) => {
	const navigate = useNavigate();
	const { refreshAuthState } = useGuestAuth();

	const timeoutIdRef = useRef(null);

	const handleSuccessRedirect = async (timeoutId) => {
		if (!params.fromQuiz) {
			await refreshAuthState();
		}

		if (params.isTokenPayment) {
			storageManager.payment.clearTokenBaseline();
		}

		const destination = buildRedirectDestination(params);

		timeoutIdRef.current = window.setTimeout(() => {
			navigate(destination, { replace: true });
		}, ORDER_STATUS_TIMING.SUCCESS_REDIRECT_DELAY_MS);
	};

	useEffect(() => {
		if (phase !== ORDER_STATUS_PHASE.SUCCESS) {
			return;
		}

		handleSuccessRedirect();

		return () => {
			clearTimeout(timeoutIdRef?.current);
		};
	}, [navigate, params, phase, refreshAuthState]);
};

export default useOrderStatusSuccessRedirect;
